/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_In_Info_Edit_SavingInputs */

const vi_scl_in_info_edit_saving = /** @type {(inputs: Scl_In_Info_Edit_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang lưu...`)
};

/**

* @param {Scl_In_Info_Edit_SavingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_in_info_edit_saving = /** @type {((inputs?: Scl_In_Info_Edit_SavingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_In_Info_Edit_SavingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_in_info_edit_saving(inputs)
});